import {NgModule} from '@angular/core';
import {CommonModule} from '@angular/common';
import {ResultsComponent} from './results/results.component';
import {ViewRoundsComponent} from './view-rounds/view-rounds.component';
import {NgbModalModule} from '@ng-bootstrap/ng-bootstrap';
import {FormsModule} from '@angular/forms';
import {DataTablesModule} from 'angular-datatables';
import {ModifyRoundsComponent} from './modify-rounds/modify-rounds.component';
import {NguiAutoCompleteModule} from '@ngui/auto-complete';
import {PracticeRoundComponent} from '../bidding-rounds/practice-round/practice-round.component';
import {PickListModule, TooltipModule} from 'primeng/primeng';
import {RouterModule} from '@angular/router';
import { ProcessingOutputComponent } from './processing-output/processing-output.component';

@NgModule({
    declarations: [ViewRoundsComponent, ResultsComponent, ModifyRoundsComponent, ProcessingOutputComponent],
    imports: [CommonModule, NgbModalModule, FormsModule, DataTablesModule, NguiAutoCompleteModule, PickListModule, TooltipModule,
        RouterModule]
})
export class BiddingModule {
}
